module.exports = "<script type=\"text/html\" id=\"survey-question-custom\">\n  <!-- ko template: { name: question.contentQuestion.koTemplateName(), data: question.contentQuestion, as: 'question', afterRender: question.contentQuestion.koQuestionAfterRender } -->\n  <!-- /ko -->\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/question-custom.html
// module id = 83
// module chunks = 0